/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface VisionSdkTrainingDataMeasurementIdZipGet$Params {
  measurementId: string;
}

export function visionSdkTrainingDataMeasurementIdZipGet(http: HttpClient, rootUrl: string, params: VisionSdkTrainingDataMeasurementIdZipGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, visionSdkTrainingDataMeasurementIdZipGet.PATH, 'get');
  if (params) {
    rb.path('measurementId', params.measurementId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as VivaLiteScanStrictHttpResponse<void>;
    })
  );
}

visionSdkTrainingDataMeasurementIdZipGet.PATH = '/VisionSdk/TrainingData/{measurementId}/zip';
